
























































import { Vue, Prop, Component, Watch } from "@/shared/vuepack";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";

@Component({
  components: {
    Input,
    Button,
  },
})
export default class VerificationCode extends Vue {
  $validator: Validator;
  local: string | number = "";

  @Prop([String, Number])
  value: string | number;

  @Prop({required: false, default: "fa-envelope"})
  faIcon: string;

  @Prop()
  onSubmit: () => Promise<void>;

  @Prop(({required: false}))
  onResendCode: () => Promise<void>;

  @Prop ({required: false, default: 2})
  resendWaitTimeInSeconds: number;

  @Prop(({required: false}))
  isSubmissionDisabled: boolean;

  disableResendCode = true;
  timerInSeconds = null;
  isVerifying = false;

  @Watch("value")
  onValueChanged (newValue) {
    if (this.local === newValue) return;
    this.local = newValue;
  }

  @Watch("local")
  onLocalValueChanged (newValue) {
    if (this.value === newValue) return;
    this.$emit("input", newValue);
  }

  pauseAndSetDisplayTimerUntil (resendWaitTime): Promise<void>  {
    return new Promise( resolve => {
      this.timerInSeconds = resendWaitTime;
      const disableInterval = setInterval(() => {
        if (this.timerInSeconds > 1) {
          this.timerInSeconds -= 1;
        } else {
          clearInterval(disableInterval);
          this.timerInSeconds = null;
          resolve();
        }
      } , 1000 );
    });
  }

  mounted () {
    this.local = this.value;
    this.pauseAndSetDisplayTimerUntil(this.resendWaitTimeInSeconds)
    .then(() => this.disableResendCode = false);
  }

  validate (): Promise<void> {
    this.isVerifying = true;
    return this.$validator.validateAll()
    .then(r => {
        if (!r) {
          this.isVerifying = false;
          throw r;
        }
    });
  }

  onSubmitVerify () {
    this.validate()
      .then( () => {
        this.onSubmit()
          .then(() =>
            this.isVerifying = false
        );
    })
    .catch(() => this.isVerifying = false );
  }

  onResendCodeCalled () {
    this.disableResendCode = true;
    return this.onResendCode()
      .then(() =>
        this.pauseAndSetDisplayTimerUntil(this.resendWaitTimeInSeconds)
        .then(() => this.disableResendCode = false )
      );
  }

  get isDisabled () {
    return this.isSubmissionDisabled || this.$validator.errors.any() || this.isVerifying;
  }

  get isResendCodeDisabled () {
    return this.disableResendCode;
  }

  get showResendCode () {
    return this.onResendCode !== undefined;
  }
}
